import React from 'react';
import { Link } from 'react-router-dom';
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';

const Footer = () => {
  const footerLinks = {
    company: [
      { name: 'Hakkımızda', href: '/about' },
      { name: 'Kariyer', href: '/careers' },
      { name: 'Basın', href: '/press' },
      { name: 'Haberler', href: '/news' },
    ],
    customer: [
      { name: 'İletişim', href: '/contact' },
      { name: 'Destek', href: '/support' },
      { name: 'Sipariş Takibi', href: '/track-order' },
      { name: 'İade ve Değişim', href: '/returns' },
    ],
    legal: [
      { name: 'Gizlilik Politikası', href: '/privacy' },
      { name: 'Kullanım Koşulları', href: '/terms' },
      { name: 'Çerez Politikası', href: '/cookies' },
      { name: 'Mesafeli Satış Sözleşmesi', href: '/distance-sales-contract' },
      { name: 'Üyelik Sözleşmesi', href: '/membership-agreement' },
      { name: 'İade ve İptal', href: '/return-cancel' },
      { name: 'Ön Bilgilendirme', href: '/preliminary-information' },
      { name: 'Yasal Bilgiler', href: '/legal' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-luxury font-bold bg-gradient-to-r from-luxury-400 to-luxury-600 bg-clip-text text-transparent mb-4">
              FielHome
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Türkiye'nin önde gelen lüks mobilya markası. 14 yıldır kalite, 
              estetik ve konforu bir araya getirerek hayalinizdeki yaşam alanlarını oluşturuyoruz.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 text-luxury-400" />
                <span className="text-gray-300">+90 552 229 90 07</span>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-luxury-400" />
                <span className="text-gray-300">info@fielhome.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPinIcon className="h-5 w-5 text-luxury-400" />
                <span className="text-gray-300">Mahmudiye, Ankara Cd. No:90, 16400 İnegöl/Bursa</span>
              </div>
              <div className="flex items-center space-x-3">
                <ClockIcon className="h-5 w-5 text-luxury-400" />
                <span className="text-gray-300">Pzt-Cum: 09:00-18:00</span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Şirket</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-luxury-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Müşteri Hizmetleri</h4>
            <ul className="space-y-2">
              {footerLinks.customer.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-luxury-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Yasal</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-luxury-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h4 className="text-xl font-semibold text-white mb-2">
                Özel Tekliflerden Haberdar Olun
              </h4>
              <p className="text-gray-300">
                Yeni koleksiyonlar ve indirimlerden ilk siz haberdar olun.
              </p>
            </div>
            <div className="flex space-x-3">
                              <input
                  type="email"
                  placeholder="E-posta adresiniz"
                  className="flex-1 px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-luxury-500 focus:border-transparent"
                />
                <button className="bg-gradient-to-r from-luxury-500 to-luxury-600 text-white px-6 py-3 rounded-lg font-semibold hover:from-luxury-600 hover:to-luxury-700 transition-all duration-300">
                  Abone Ol
                </button>
            </div>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 FielHome. Tüm hakları saklıdır.
          </div>
          
          <div className="flex space-x-6">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-luxury-400 transition-colors duration-200"
            >
              Facebook
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-luxury-400 transition-colors duration-200"
            >
              Instagram
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-luxury-400 transition-colors duration-200"
            >
              Twitter
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-luxury-400 transition-colors duration-200"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 